import React from "react";
import {
  ChartLineIcon,
  ClipboardListIcon,
  CubesIcon,
  HomeIcon,
  LayerGroupIcon,
  ShieldAltIcon,
  ToolsIcon
} from "@patternfly/react-icons";
import type { NavigationItem, User, ViewKey } from "../types";


export const APP_VERSION = "20260906-user-access-brand-1";

export const fallbackNavigation: NavigationItem[] = [
  { key: "dashboard", label: "Today", group: "direct", icon: <HomeIcon /> },
  { key: "po_request", label: "Branch Requests", group: "inventory", icon: <ClipboardListIcon /> },
  { key: "store_inventory", label: "Inventory Actions", group: "inventory", icon: <LayerGroupIcon /> },
  { key: "add_inventory", label: "Add to Inventory", group: "inventory", icon: <ClipboardListIcon /> },
  { key: "vendor_po", label: "Vendor Purchasing", group: "inventory", icon: <ClipboardListIcon /> },
  { key: "production", label: "Dispatch Control", group: "inventory", icon: <CubesIcon /> },
  { key: "finance_close", label: "Finance Close", group: "finance", icon: <ShieldAltIcon /> },
  { key: "sales", label: "POS & Sales", group: "finance", icon: <ChartLineIcon /> },
  { key: "audit", label: "Audit Trail", group: "finance", icon: <ShieldAltIcon /> },
  { key: "sync_status", label: "Offline Uploads", group: "finance", icon: <ShieldAltIcon /> },
  { key: "report_daily_inventory", label: "Daily Inventory", group: "reports", icon: <ChartLineIcon /> },
  { key: "report_all_branches_inventory", label: "All Branches Inventory", group: "reports", icon: <ChartLineIcon /> },
  { key: "report_product_sales_count", label: "Product Sales Count", group: "reports", icon: <ChartLineIcon /> },
  { key: "admin", label: "Master Setup", group: "setup", icon: <ToolsIcon /> },
  { key: "db_edits", label: "POS Item Links", group: "setup", icon: <ToolsIcon /> }
];

export function iconForView(key: ViewKey): React.ReactNode {
  return fallbackNavigation.find(item => item.key === key)?.icon || <ClipboardListIcon />;
}

export function visibleTabs(user: User | null): Set<ViewKey> {
  return new Set(user?.tabs || []);
}

export function navLabel(item: { key: ViewKey; label: string }, user: User | null): string {
  return user?.tab_labels?.[item.key] || item.label;
}
